import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";
import { gridResourcesCurrentCleanResourcesSelector } from "@/store/resources-grid/selectors/clean/resources/gridResourcesCurrentCleanResourcesSelector";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";

type ReturnType = Record<string, AllTypeResourcesData[]>;

export const gridResourcesCurrentCleanResourcesGroupedByAccountIdSelector =
  createDraftSafeSelector(
    [gridResourcesCurrentCleanResourcesSelector],
    (resources): ReturnType => {
      return resources.reduce((acc, resource) => {
        const accountId = isResourceKubernetes(resource.resource)
          ? resource.resource.cluster.id
          : resource.resource.account.id;

        if (!acc[accountId]) {
          acc[accountId] = [];
        }

        acc[accountId].push(resource);

        return acc;
      }, {} as ReturnType);
    },
  );
